import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Dialog from '@mui/material/Dialog';
import Link from '@mui/material/Link';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
var HelpDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    return (_jsxs(Dialog, { open: open, onClose: onClose, children: [_jsx(DialogTitle, { children: "Help" }), _jsxs(DialogContent, { children: [_jsx(Typography, { gutterBottom: true, variant: "subtitle2", children: "If you have any issue please contact IT Helpdesk" }), _jsx(Typography, { gutterBottom: true, children: "020 361 51555" }), _jsx(Typography, { gutterBottom: true, children: _jsx(Link, { href: "mailto:it.helpdesk@mailnewspapers.co.uk", children: "it.helpdesk@mailnewspapers.co.uk" }) })] }), _jsx(DialogActions, { children: _jsx(Button, { onClick: onClose, autoFocus: true, children: "OK" }) })] }));
};
export default HelpDialog;
